function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function compactItemVerticalBorder(token, parentCls) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, "&-item:not(".concat(parentCls, "-last-item)"), {
    marginBottom: -token.lineWidth
  }), _defineProperty(_ref, '&-item', {
    '&:hover,&:focus,&:active': {
      zIndex: 2
    },
    '&[disabled]': {
      zIndex: 0
    }
  }), _ref;
}

function compactItemBorderVerticalRadius(prefixCls, parentCls) {
  var _ref2;

  return _ref2 = {}, _defineProperty(_ref2, "&-item:not(".concat(parentCls, "-first-item):not(").concat(parentCls, "-last-item)"), {
    borderRadius: 0
  }), _defineProperty(_ref2, "&-item".concat(parentCls, "-first-item:not(").concat(parentCls, "-last-item)"), _defineProperty({}, "&, &".concat(prefixCls, "-sm, &").concat(prefixCls, "-lg"), {
    borderEndEndRadius: 0,
    borderEndStartRadius: 0
  })), _defineProperty(_ref2, "&-item".concat(parentCls, "-last-item:not(").concat(parentCls, "-first-item)"), _defineProperty({}, "&, &".concat(prefixCls, "-sm, &").concat(prefixCls, "-lg"), {
    borderStartStartRadius: 0,
    borderStartEndRadius: 0
  })), _ref2;
}

export function genCompactItemVerticalStyle(token) {
  var compactCls = "".concat(token.componentCls, "-compact-vertical");
  return _defineProperty({}, compactCls, Object.assign(Object.assign({}, compactItemVerticalBorder(token, compactCls)), compactItemBorderVerticalRadius(token.componentCls, compactCls)));
}